import React, { useState } from 'react';
import classNames from 'classnames';
import './FlowStageInputMetric.scss';

import Div100Vh from 'react-div-100vh'

export const HeightDefaults = {
  metricName: 'height',
  metricUnits: 'cm',
  blurb: '3D Measure uses your height to improve the accuracy of your measurements and avatar.',
  buttonText: 'Continue',
};
export const WeightDefaults = {
  metricName: 'weight',
  metricUnits: 'kg',
  blurb: '3D Measure uses your weight to calculate our BMI and helps the accuracy of your measurements and avatar.',
  buttonText: 'Create Avatar',
};

const FlowStageInputMetric = ({
  onInputChanged,
  next,
  metricName,
  metricUnits,
  metricVal,
  blurb,
  buttonText,
}) => {
  const [val, setVal] = useState(metricVal || '');

  const handleNumericInput = (evt) => {
    console.log('handleNumericInput')
    if (evt && evt.target) {
      const v = evt.target.value;
      console.log('handleNumericInput', v)
      const float = parseFloat(v);
      const re = /^\d+\.\d{0,2}$/;
      if (re.test(v) || !isNaN(float) || v === '') {
        setVal(v);
      }
    }
  };

  const handleClick = () => {
    if (!!val) {
      onInputChanged(val);
      next();
    }
  };

  return (
    <Div100Vh className="flow-stage-input-metric--container">
      <header className={classNames({
        last: metricName === WeightDefaults.metricName
      })}>
        <h2>What{`'`}s your {metricName}?</h2>
      </header>
      <label>
        <label>{`${metricName} (${metricUnits})`}</label>
        <input
          name={metricName}
          type="text"
          placeholder={`${metricName} (${metricUnits})`}
          value={val}
          onChange={(evt) => handleNumericInput(evt)}
        />
      </label>
      <p>{blurb}</p>

      <button onClick={handleClick} disabled={!val}>
        {buttonText}
      </button>
    </Div100Vh>
  );
};

export default FlowStageInputMetric;
